<template>
  <div
    style="position:fixed; top:0; left:0; right:0; z-index:1000; background-color:#ffffff; overflow:visible;"
    :style="{ 'min-height': appBarMinHeight + 'px' }"
  >
    <div>
        <img
          :src="headerTopLinePng"
          style="height:20px; width:100%; display:block;"
        />
        <div style="display:flex; justify-content: space-between; padding: 10px;">
          <img
            :src="logoGif"
            style="max-width:170px; min-width:170px; height:40px; object-fit:contain; flex-shrink:0;"
          />
          <div style="display: grid; margin: 3px; min-width: 0; overflow: hidden;">
            <div>
              <TelButton v-if="agencyTel && !telIconHidden" :agencyTel="agencyTel" buttonClass="float-right" />
            </div>
            <div class="mt-1" style="font-size:10px; line-height: 100%; text-align: center; word-break: break-all;">
              {{ $t('label.agencyName') }} : {{ agencyName }}
            </div>
          </div>
        </div>

        <div v-if="!headerTitleHidden" class="stepper-title">
          <img
            :src="headerTitlePng"
            style="height:35px; width:100%; display:block;"
          />
          <div class="stepper-title-text font-weight-bold">{{ stepperTitle() }}</div>
        </div>

        <div v-if="!stepperHidden" class="stepper">
          <template v-for="item in stepper" width="auto">
            <template v-if="item.step === stepPoint">
              <!-- 現在の状態 -->
              <div
                class="step active"
                :key="item.step"
                :style="widthCalculation(item.step)"
              >
                <div class="clickable">
                  <p class="text-center hearder-font-size text-white font-weight-bold mb-0">
                    {{ item.text }}
                  </p>
                  <p
                    v-if="isReviewContract"
                    class="text-center hearder-font-size text-white mb-0"
                  >
                    {{ reviewContractPageRange }}
                  </p>
                </div>
              </div>
            </template>
            <template v-else-if="item.step < stepPoint">
              <!-- 通過済みの状態 -->
              <div
                class="step done"
                :key="item.step"
                :style="widthCalculation(item.step)"
              >
                <router-link
                  :to="{
                    name: item.stepName,
                    hash: item.hash,
                    params: item.params,
                  }"
                  style="text-decoration: none;"
                >
                  <div class="clickable">
                    <v-container
                      class="ma-auto px-0"
                      fill-height
                      style="height:50px;"
                    >
                      <template v-if="checkPc">
                        <p class="text-center ma-auto">{{ item.text }}</p>
                      </template>
                      <template v-else>
                        <p class="text-center ma-auto icon">{{ item.step }}</p>
                      </template>
                    </v-container>
                  </div>
                </router-link>
              </div>
            </template>
            <template v-else>
              <!-- 未到達の状態 -->
              <div
                class="step"
                :key="item.step"
                :style="widthCalculation(item.step)"
              >
                <div class="clickable">
                  <v-container
                    class="ma-auto px-0"
                    fill-height
                    style="height:50px;"
                  >
                    <template v-if="checkPc">
                      <p class="text-center ma-auto">{{ item.text }}</p>
                    </template>
                    <template v-else>
                      <p class="text-center ma-auto icon">{{ item.step }}</p>
                    </template>
                  </v-container>
                </div>
              </div>
            </template>
          </template>
        </div>
        <div
          v-if="!stepperHidden"
          style="position:absolute; bottom:0; left:0; right:0; height:3px; background: linear-gradient(to bottom, #888888, #f4f4f4);"
        ></div>
      </div>
  </div>
</template>

<script>
import { contractorHeaderBreakPoint } from '@/lib/const';
import TelButton from '@/components/molecules/contractor/TelButton';
import logoGif from '@/assets/img/logo.gif';
import headerTopLinePng from '@/assets/img/header-top-line.png';
import headerTitlePng from '@/assets/img/header-title.png';

export default {
  name: 'Header',
  props: {
    stepPoint: Number,
    agencyName: String,
    agencyTel: String,
    stepper: Array,
    applicationFormPage: String,
    applicationFormTotalPage: Number,
    stepperHidden: Boolean,
    headerTitleHidden: Boolean,
    telIconHidden: Boolean,
    stepperText: String,
  },
  components: { TelButton },
  data() {
    return {
      logoGif,
      headerTopLinePng,
      headerTitlePng,
      offsetTop: 0,
      checkPc: false,
      isExtended: false,
    };
  },
  computed: {
    agencyTelWidth() {
      return this.checkPc ? '230px' : '144px';
    },
    appBarMinHeight() {
      return this.stepperHidden ? 80 : 200;
    },
    isReviewContract() {
      return this.applicationFormTotalPage && this.applicationFormPage;
    },
    reviewContractPageRange() {
      return `${this.applicationFormPage} / ${this.applicationFormTotalPage}`;
    },
  },
  methods: {
    stepperTitle() {
      const title = `${this.stepPoint}. ${this.stepperText}`;

      if (this.isReviewContract) {
        return `${title}(${this.reviewContractPageRange})`;
      }
      return title;
    },
    widthCalculation(step) {
      const totalSize = this.stepper.length + 3;
      const width =
        step === this.stepPoint ? (100 / totalSize) * 4 : 100 / totalSize;
      return 'width:' + width + 'vw';
    },
    // resizeのたびに発火
    handleResize: function() {
      this.checkPc = window.innerWidth > contractorHeaderBreakPoint;
    },
  },
  created() {
    if (!this.stepperHidden) {
      this.isExtended = true;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.checkPc = window.innerWidth > contractorHeaderBreakPoint;
  },
  beforeUnmount: function() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss">
@import '@/styles/index.scss';

$bg-color: #d5ebfe;
$fg-color: #000;
$bg-done-color: #8cb8fd;
$fg-done-color: #fff;
$bg-active-color: #8cb8fd;
$fg-active-color: #fff;
$title-color: #fff;

$margin-left: 5px; // 矢羽の間隔
$arrow-width: 20px; // 矢羽の角度
$arrow-height: 50px;

@mixin before($color) {
  content: '';
  position: absolute;
  top: 50%;
  margin-top: -1 * $arrow-height;
  border-width: $arrow-height 0 $arrow-height $arrow-width;
  border-style: solid;
  border-color: $color transparent;
  left: -1 * $arrow-width;
}

@mixin after($color) {
  content: '';
  position: absolute;
  top: 50%;
  margin-top: -1 * $arrow-height;
  border-top: $arrow-height solid transparent;
  border-bottom: $arrow-height solid transparent;
  border-left: $arrow-width solid $color;
  right: -1 * $arrow-width;
}

@mixin step($fg-color, $bg-color) {
  .clickable {
    color: $fg-color;
    background-color: $bg-color;
    &:before {
      @include before($bg-color);
    }
    &:after {
      @include after($bg-color);
    }
  }
  &:hover .clickable {
    $bg-color: darken($bg-color, 10%);
    background-color: $bg-color;
    &:before {
      @include before($bg-color);
    }
    &:after {
      @include after($bg-color);
    }
  }
}

.stepper-title {
  position: relative;

  .stepper-title-text {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    margin-left: 10px;
    font-size: 18px;
    color: $title-color;
  }
}

.stepper {
  display: flex;
  word-break: normal;
  overflow-y: hidden;
  margin: 10px 50px 0 50px;

  .step {
    margin: 0;
    margin-left: $margin-left;
    margin-right: $arrow-width;
    font-size: 12px;

    &:first-child {
      margin-left: 0 !important;
      .clickable:before {
        content: none !important;
      }
    }

    .clickable {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 50px;
      max-height: 50px;
      position: relative;
    }

    @include step($fg-color, $bg-color);

    &.done {
      @include step($fg-done-color, $bg-done-color);
    }

    &.active {
      @include step($fg-active-color, $bg-active-color);
      font-size: 16px;
      word-break: keep-all;
    }
  }
}

.icon {
  align-items: center;
  border-radius: 50%;
  font-size: 10px;
  justify-content: center;
  height: 15px !important;
  width: 15px !important;
  min-width: 15px !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: white;
  color: #000;
}

// ヘッダーフロー画像が動的にサイズ調整されるため文字サイズも調整
@media screen and (max-width: 500px) {
  .hearder-font-size {
    font-size: 13px;
  }
}
@media screen and (max-width: 400px) {
  .hearder-font-size {
    font-size: 10px;
  }
}

#agencyTel > span {
  font-size: 10px !important;
}

.v-toolbar__content {
  padding: 0 !important;
}
</style>
